<template>
  <div class="tr-rep__container">
    <div class="tr-rep__header">
      <div class="tr-rep__title">
        {{ $t('tenancy.representative.title') }} ({{ $t('handover.internalUseOnly') }})
      </div>
      <FormActionBtns
        v-if="hasUpdateTrRepAccess"
        v-model="modeStatus"
        :disableEdit="isTrEditing"
        :hiddenAdd="true"
        :onCancel="cancel"
        :onSave="save"
      />
    </div>
    <ViewVue v-if="!isEditing" />
    <EditVue
      v-else
      :trReps.sync="trRepAccounts"
    />
    <HKLInviteModal
      ref="inviteAllRef"
      :listTitle="$t('tenancy.representative.title')"
      :accountsList="needInviteAccounts"
      @onInviteClick="() => inviteAll(needInviteAccounts)"
    />
  </div>
</template>

<script>
import { computed, inject, onUnmounted, ref, unref } from 'vue-demi'
import lodash from 'lodash'
import allSettled from 'promise.allsettled'
import { inviteTrRepAccounts, upsertTrRepAccounts } from '@/api/tenancies/request'
import FormActionBtns from '@/controls/FormActionBtns'
import { STATUS } from '@/controls/FormActionBtns/container'
import { TR_EVENT_KEYS, TR_PROVIDE_KEYS } from '@/pages/ccd/tenancy.consts'
import { useRouteParamId } from '@/router/useRouter'
import eventBus from '@/utils/eventBus'
import HKLInviteModal from '@/controls/Modal/InviteModal'
import { useRefModal } from '@/controls/Modal/modal.hook'
import EditVue from './Edit.vue'
import ViewVue from './View.vue'
import { hasUpdateTrRepAccess, useTrRepAccounts } from './hook'

export default {
  components: {
    HKLInviteModal,
    ViewVue,
    EditVue,
    FormActionBtns,
  },
  setup () {
    const isTrEditing = inject(TR_PROVIDE_KEYS.DETAIL_EDITING)
    const isEditing = computed(() => {
      const result = unref(modeStatus) === STATUS.EDIT
      eventBus.emit(TR_EVENT_KEYS.TR_REPS_IS_EDITING, result)
      return result
    })
    const trRepAccounts = ref([])
    const tenancyId = useRouteParamId()
    const modeStatus = ref(STATUS.VIEW)
    const { accounts, refresh } = useTrRepAccounts(tenancyId)
    const { open: openInviteAllModal, close: closeInviteAllModal, modal: inviteAllRef } = useRefModal()
    const cancel = () => {}
    const save = async () => {
      await upsertTrRepAccounts(unref(tenancyId), unref(trRepAccounts))
      await refresh()
      if (unref(shouldOpenInviteAllModal)) {
        openInviteAllModal()
      }
    }
    const needInviteAccounts = computed(() => {
      return unref(accounts).filter((item) => !item.rawInviteAt)
    })
    const shouldOpenInviteAllModal = computed(() => {
      return hasUpdateTrRepAccess && unref(needInviteAccounts).length > 0
    })
    const inviteAll = async (accounts) => {
      const promises = lodash.castArray(accounts).map(async (item) => {
        await inviteTrRepAccounts(unref(tenancyId), item.accountId)
      })
      await allSettled(promises)
      closeInviteAllModal()
      await refresh()
    }
    onUnmounted(() => {
      eventBus.off(TR_EVENT_KEYS.TR_REPS_IS_EDITING)
    })
    return {
      hasUpdateTrRepAccess,
      inviteAllRef,
      inviteAll,
      needInviteAccounts,
      isTrEditing,
      trRepAccounts,
      isEditing,
      modeStatus,
      cancel,
      save,
    }
  },
}
</script>

<style lang="scss" scoped>

.tr-rep {
  &__container {
    padding: 10px
  }
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5px;
  }
  &__title {
    color: #083e62;
    font-size: 20px;
    font-weight: bold;
  }
}
</style>
